// src/lib/pending-temp-password.ts
//
// Ponte entre o login e a troca obrigatória de senha. Quem entra com a senha
// temporária é mandado para "Crie sua senha", que precisa dela como senha atual
// — pedir de novo o que a pessoa acabou de digitar confunde, e o navegador
// costuma autopreencher o campo com OUTRA senha salva para o mesmo endereço
// (medido: o campo chegava ao back com 10 caracteres, a temporária tem 15).
//
// Só em MEMÓRIA do módulo — nunca localStorage/sessionStorage. Recarregar a
// página perde o valor, e a tela volta a pedir a temporária. Vale por poucos
// minutos e é apagada assim que a troca dá certo (ou no logout).
//
// Ler e apagar são separados de propósito: o StrictMode do React chama o
// inicializador do useState duas vezes em dev, e um "ler-e-apagar" deixaria a
// segunda chamada sem o valor.

const TTL_MS = 10 * 60 * 1000;

let pending: { password: string; at: number } | null = null;

export function rememberTempPassword(password: string): void {
  pending = { password, at: Date.now() };
}

export function peekTempPassword(): string | null {
  if (!pending) return null;
  if (Date.now() - pending.at > TTL_MS) {
    pending = null;
    return null;
  }
  return pending.password;
}

export function clearTempPassword(): void {
  pending = null;
}
